<template>
  <div class="affiliate text-light flex-column">
    <div class="background bg-1">
      <img :src="require(`@/assets/capas/ser-um-afiliado.webp`)">
    </div>
    <header>
      <div class="title title-1">Ser um Afiliado</div>
    </header>
    <div class="call-to-action text-dark flex align-center justify-space-between">
      <div class="flex align-center">
        <svg width="115" height="102" viewBox="0 0 115 102" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="115" height="102" rx="23" fill="#F5F5F5"/>
          <path d="M52 70.502V42.0408C52 42.0408 52.0977 41.5415 43.6988 44.038C35.2999 46.5346 34.5358 51.0693 37.7723 58.019C41.0088 64.9688 41.1038 72 44.7364 72C48.3691 72 52 70.502 52 70.502Z" stroke="#00A859"/>
          <path d="M61 68.5V42.5C65.3073 42.5219 66 42.4998 70 43.9999C74 45.5 85 60 77.5 63C70 66 66.7179 66.7306 61 68.5Z" stroke="#BDBDBD"/>
          <path d="M74 37H34C34 37 66 28.0001 69.5 28C73 27.9999 74 37 74 37Z" stroke="#ED3237"/>
        </svg>
        <div class="subtitle-1">
          TENHA MÓVEIS TOPÁZIO <br> EM SUA LOJA
        </div>
      </div>
      <div class="flex-column align-center">
        <a href="#form">
          <button class="btn btn-outlined">Faça seu cadastro</button>
        </a>
        <button @click="$router.push({ name: 'Representatives' })" class="btn btn-outlined">Fale com um Representante</button>
      </div>
    </div>
    <div class="content">
      <div class="benefits">
        <div v-for="(benefit, index) in benefits" :key="index" class="benefit">
          <div class="bg">
            <div class="title flex align-center justify-space-between">
              <div class="title-1">
                {{ benefit.title }}
              </div>
              <img :src="require(`@/assets/icons/${benefit.icon}.svg`)">
            </div>
            <div class="title-4">
              {{ benefit.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <form class="form" id="form">
      <div class="title-2">Quer vender nossos produtos em sua loja?</div>
      <div class="body-2">Preencha o formulário abaixo, que entraremos em contato.</div>
      <form ref="form" @submit.prevent="sendEmail" class="form-content flex align-left">
        <div class="img">
          <div>
            <img :src="require(`@/assets/topazinho/topazinho-1.png`)">
          </div>
        </div>
        <div class="fields flex-column">
          <div class="flex justify-space-between">
            <div class="flex-column">
              <input type="text" autocomplete="off" :disabled="sending" v-model="form.nome" name="nome" placeholder="Seu nome completo">
              <input type="email" autocomplete="off" :disabled="sending" v-model="form.email" name="email" placeholder="Email">
              <input type="tel" autocomplete="off" :disabled="sending" v-model="form.whatsapp" name="whatsapp" placeholder="Whatsapp">
              <input type="tel" autocomplete="off" :disabled="sending" v-model="form.telefone" name="telefone" placeholder="Telefone">
            </div>
            <div class="flex-column">
              <input type="text" autocomplete="off" :disabled="sending" v-model="form.loja" name="loja" placeholder="Nome da loja">
              <input type="tel" autocomplete="off" :disabled="sending" v-model="form.cnpj" name="cnpj" placeholder="CNPJ">
              <input type="text" autocomplete="off" :disabled="sending" v-model="form.cidade" name="cidade" placeholder="Cidade">
              <input type="text" autocomplete="off" :disabled="sending" v-model="form.estado" name="estado" placeholder="Estado">
            </div>
          </div>
          <textarea name="message" autocomplete="off" :disabled="sending" v-model="form.message" placeholder="Mensagem"></textarea>
          <button type="submit" :disabled="!formOk" class="btn btn-primary">Enviar</button>
        </div>
        <div class="sending flex-column align-center">
          <div class="svg">
            <svg class="loading" width="84" height="82" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 43.5019V15.0406C19 15.0406 19.0977 14.5413 10.6988 17.0379C2.29988 19.5345 1.5358 24.0692 4.77232 31.0189C8.00884 37.9686 8.10381 44.9999 11.7364 44.9999C15.3691 44.9999 19 43.5019 19 43.5019Z" stroke="#00A859" />
              <path d="M28 41.4999V15.4999C32.3073 15.5217 33 15.4996 37 16.9998C41 18.4999 52 32.9999 44.5 35.9999C37 38.9999 33.7179 39.7305 28 41.4999Z" stroke="#D2D3D5" />
              <path d="M41 10H1C1 10 33 1.00014 36.5 1C40 0.999862 41 10 41 10Z" stroke="#ED3237" />
            </svg>
            <div class="subtitle-5 text-white">Enviando</div>
          </div>
        </div>
      </form>
    </form>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'

export default {
  name: 'Affiliate',
  data () {
    return {
      form: {},
      sending: false,
      benefits: [
        {
          title: 'Logística',
          icon: 'carbon_delivery',
          text: 'Contamos com frota de caminhões 0km e uma logística especialista em soluções.Tudo feito para' +
            ' simplificar e cumprir prazos.'
        },
        {
          title: 'Confiança',
          icon: 'handshake',
          text: 'A nossa história sempre foi marcada por pessoas. Acreditamos que manter confiança e estreitar os laços' +
            ' com todos os que se relacionam conosco é crucial para parcerias sólidas e duráveis.'
        },
        {
          title: 'Tecnologia',
          icon: 'hardware',
          text: 'Investimos em maquinários da mais alta tecnologia, para garantir a entrega de produtos de' +
            ' qualidade, e acima de tudo, contar com maior agilidade no processo.Venha crescer com a gente!'
        }
      ]
    }
  },
  mounted () {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()

        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        })
      })
    })
  },
  computed: {
    formOk () {
      return Boolean(this.form.nome && this.form.email && this.form.whatsapp && this.form.telefone && this.form.loja && this.form.cnpj && this.form.cidade && this.form.estado && this.form.message)
    }
  },
  methods: {
    async sendEmail () {
      this.sending = true
      document.querySelector('.form .sending').style.display = 'flex'
      await emailjs.sendForm('service_6eaca5q', 'template_3eij75o', this.$refs.form, 'user_TXRTNr2XktCGsRf8jRvkk')
        .then(() => {
          console.log('enviado')
          this.form = {}
          document.querySelector('.form .sending').style.display = 'none'
          this.sending = false
        }, (error) => {
          console.log(error)
          document.querySelector('.form .sending').style.display = 'none'
          this.sending = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.affiliate {
  justify-content: start;
  position: relative;
  scroll-behavior: smooth;
}
.affiliate header{
  padding: 40px 80px;
  margin-top: 50px;
  margin-bottom: 13vw;
  text-align: left;
}
@media screen and (max-width: 425px){
  .affiliate header{
    padding: 40px 40px;
  }
  #content {
    margin: 0 0;
  }
}
.affiliate .background {
  position: absolute;
  overflow: hidden;
  top: -170px;
  left: -15vw;
  z-index: 0;
  width: 120vw;
  min-height: 430px;
  max-height: 430px;
  border-radius: 17%;
  transform: rotate(-3.5deg);
  box-shadow: 0px 3px 5px rgba(80, 80, 80, 0.52);
  img {
    width: 103%;
    margin-top: -90px;
  }
}
@media screen and (max-width: 930px) {
  .affiliate .background {
    img {
      margin-top: 10px;
    }
  }
}
@media screen and (max-width: 730px) {
  .affiliate .background {
    img {
      margin-top: 80px;
    }
  }
}
@media screen and (max-width: 575px) {
  .affiliate .background {
    img {
      width: 120%;
      min-width: 664px;
      margin-left: -30px;
      margin-top: 100px;
    }
  }
}
.affiliate .call-to-action{
  background: #E1E1E1;
  padding: 170px 70px 50px 70px;
  margin-top: -180px;
  text-align: left;
  div {
    gap: 14px;
  }
  .subtitle-1{
    line-height: 20px;
    font-size: 16px;
    color: #505050;
  }
  .btn {
    transform: scale(.8);
    min-width: 280px;
  }
}
.affiliate .benefits {
  margin-top: 50px;
  width: 100%;
  color: #EAEAEA;
}
.affiliate .benefits .benefit {
  display: flex;
  width: 90vw;
  max-width: 1296px;
  flex-direction: row;
  margin: auto;
}
.affiliate .benefits .benefit:nth-child(2) {
  flex-direction: row-reverse;
  margin-top: -10%;
}
.affiliate .benefits .benefit:nth-child(3) {
  margin-top: -10%;
}
.affiliate .benefit .bg {
  width: 55vw;
  height: 35vw;
  max-width: 713px;
  max-height: 479px;
  border-radius: 10px;
  padding: 0 40px 20px 40px;
  .title {
    margin-top: 27px;
  }
  .title-4 {
    text-align: left;
    line-height: 160%;
    margin-top: 10%;
  }
  .title-1:after {
    background: #FF0C0C;
  }
  img {
    filter: brightness(89%);
  }
}
.affiliate .benefit:nth-child(1) .bg {
  background: #01947A;
}
.affiliate .benefit:nth-child(2) .bg {
  background: #005245;
}
.affiliate .benefit:nth-child(3) .bg {
  background: #01947A;
}
@media screen and (min-width: 1385px){
  .affiliate .call-to-action {
    margin: -220px auto 0 auto;
    padding: 170px 70px 30px 70px;
    width: 90vw;
    max-width: 1929px;
  }
  .affiliate .benefits .benefit:nth-child(2), .affiliate .benefits .benefit:nth-child(3) {
    margin-top: -120px;
  }
}
@media screen and (max-width: 1200px){
  .affiliate .call-to-action {
    margin-top: -140px;
    padding: 170px 70px 30px 70px;
  }
  .affiliate .benefits .benefit:nth-child(2), .affiliate .benefits .benefit:nth-child(3) {
    margin-top: -7%;
  }
  .affiliate .benefits .benefit {
    .bg {
      .title {
        margin-top: 15px;
      }
      .title-1 {
        font-size: 36px;
      }
      img {
        transform: scale(.8);
      }
      .title-4 {
        font-size: 22px;
        margin-top: 3%;
      }
    }
  }
}
@media screen and (max-width: 768px){
  .affiliate .call-to-action {
    margin-top: -120px;
    flex-direction: column;
    text-align: center;
    svg {
      display: none;
    }
  }
  .affiliate .benefits .benefit {
    justify-content: center;
    margin-top: 5px !important;
    .bg {
      min-width: 300px;
      width: 76vw;
      min-height: 350px;
      height: 65vw;
    }
  }
}
@media screen and (max-width: 491px){
  .affiliate .call-to-action {
    margin-top: -150px;
    padding: 200px 10px 50px 10px;
  }
  .affiliate .benefits .benefit {
    margin-top: 0 !important;
    width: 100%;
    .bg {
      width: 100%;
      border-radius: 0;
      .title-4 {
        font-size: 18px;
      }
    }
  }
}

// form
.form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #505050;
  .body-2 {
    margin-top: 10px;
  }
  .sending {
    display: none;
    content: '';
    position: absolute;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    background: rgba(78, 78, 78, 0.68);
    color: #C3C3C3 !important;
    .svg {
      margin: auto;
    }
  }
}
.form-content {
  position: relative;
  margin-top: 40px;
  .flex {
    flex-wrap: wrap;
    gap: 20px;
  }
  .img {
    width: 315px;
    height: 308px;
    margin-right: 40px;
    div {
      width: 100%;
      height: 100%;
      img {
        min-width: 315px;
        width: 120%;
        margin-left: -5%;
      }
    }
  }
  input {
    border-bottom: solid 1px #828282;
    color: #828282;
    opacity: .7;
    min-width: 211px;
    width: 30vw;
  }
  input:focus {
    opacity: 1;
  }
  input::placeholder {
    color: #828282;
    opacity: .5;
  }
  textarea {
    min-width: 265px;
    width: 49vw;
    max-width: 562px;
    height: 124px;
    background: none;
    color: #828282;
    outline: none;
    padding: 6px;
    font-weight: 600;
    border-radius: 7px;
    border-color: #828282;
    opacity: .6;
    transition: all .3s ease;
  }
  textarea:focus {
    opacity: 1;
  }
  textarea::placeholder {
    color: #828282;
    opacity: .7;
  }
  .btn {
    margin: 30px auto 0 auto;
  }
}
.form-content .sending {
  display: none;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 82, 69, 0.75);
  color: #C3C3C3 !important;
  .svg {
    margin: auto;
  }
}
.form-content.before {
  content: 'Enviando...';
  font-weight: bold;
  z-index: 1;
  position: absolute;
  margin: 170px 0 0 33vw;
}
@media screen and (max-width: 1000px){
  .form-content {
    .img {
      display: none;
    }
  }
}
@media screen and (max-width: 457px){
  .form-content {
    .flex {
      display: block;
    }
    .fields {
      align-items: center;
    }
  }
}
</style>